import * as React from 'react';
import Grid from '@mui/material/Grid';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Refresh } from '@mui/icons-material';
import Button from '@mui/material/Button';
import helpers from '../../helpers/common';
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import PaymentPageOpensIndex from './PaymentPageOpensIndex';

export default function PaymentPageOpensContainer() {
    const [searchParams] = useSearchParams();
    const [refreshId, setRefreshId] = useState(0);

    const refresh = () => setRefreshId((prev) => prev + 1);

    return (
        <React.Fragment>
            <Grid size={12}>
                <PageHeader
                    title="Открытия страницы оплаты"
                    breadcrumbs={[['Dashboard', '/'], ['Открытия страницы оплаты', '/payment-page-opens']]}
                    actions={
                        <Button onClick={refresh} variant="contained" startIcon={<Refresh />}>
                            Обновить
                        </Button>
                    }
                />
            </Grid>
            <Grid size={12}>
                <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
                    <PaymentPageOpensIndex fullPage={true} searchParams={searchParams} refreshId={refreshId} />
                </SectionCard>
            </Grid>
        </React.Fragment>
    );
}
